<div class="page-title-area">
  <div class="d-table">
    <div class="d-table-cell">
      <div class="container">
        <div class="page-title-text">
          <h2 class="animated-title" *ngIf="!loading">
            <span class="text-gradient">TOUTE L'ACTUALITÉ</span>
          </h2>
          <h2 *ngIf="loading"><p-skeleton height="2rem" width="70%"></p-skeleton></h2>
          <ul class="breadcrumb-list">
            <li><a routerLink="/" class="breadcrumb-link">ACCUEIL</a></li>
            <li><i class="icofont-simple-right"></i></li>
            <li class="current-page" *ngIf="!loading">TOUTE L'ACTUALITÉ</li>
            <li *ngIf="loading"><p-skeleton height="1rem" width="15rem"></p-skeleton></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>

<section class="featured-news-section pt-100 pb-170">
  <div class="container">
    <div class="section-header">
      <h2 class="section-title">
        <i class="icofont-star"></i>
        À la Une
      </h2>
      <p class="section-subtitle">Les articles les plus importants du moment</p>
    </div>
    
    <div class="featured-carousel" *ngIf="!loading">
      <div id="featuredCarousel" class="carousel slide" data-bs-ride="carousel">
        <div class="carousel-indicators">
          <button 
            type="button" 
            data-bs-target="#featuredCarousel" 
            [attr.data-bs-slide-to]="i" 
            [class.active]="i === 0"
            *ngFor="let article of limites; let i = index"
          ></button>
        </div>
        
        <div class="carousel-inner">
          <div 
            class="carousel-item" 
            [class.active]="i === 0"
            *ngFor="let article of limites; let i = index"
          >
            <div class="featured-slide">
              <div class="slide-image">
                <img [src]="article.media" [alt]="article.title">
                <div class="slide-overlay"></div>
              </div>
              <div class="slide-content">
                <div class="slide-meta">
                  <span class="slide-date">
                    <i class="icofont-calendar"></i>
                    {{ article.publishon_on|date:'d MMMM yyyy' }}
                  </span>
                  <span class="slide-category">
                    <i class="icofont-tag"></i>
                    Actualité
                  </span>
                </div>
                <h3 class="slide-title">{{ article.title }}</h3>
                <p class="slide-excerpt">
                  Découvrez les dernières informations et développements importants...
                </p>
                <a [routerLink]="article.slug" class="slide-btn">
                  <i class="icofont-arrow-right"></i>
                  Lire l'article
                </a>
              </div>
            </div>
          </div>
        </div>
        
        <button class="carousel-control-prev" type="button" data-bs-target="#featuredCarousel" data-bs-slide="prev">
          <i class="icofont-arrow-left"></i>
        </button>
        <button class="carousel-control-next" type="button" data-bs-target="#featuredCarousel" data-bs-slide="next">
          <i class="icofont-arrow-right"></i>
        </button>
      </div>
    </div>
    
    <!-- Loading Skeleton for Featured -->
    <div class="featured-skeleton" *ngIf="loading">
      <div class="skeleton-slide">
        <div class="skeleton-image">
          <p-skeleton height="400px" width="100%" styleClass="rounded-3"></p-skeleton>
        </div>
        <div class="skeleton-content">
          <p-skeleton height="1.5rem" width="60%" styleClass="mb-3"></p-skeleton>
          <p-skeleton height="2.5rem" width="80%" styleClass="mb-2"></p-skeleton>
          <p-skeleton height="1rem" width="100%" styleClass="mb-2"></p-skeleton>
          <p-skeleton height="1rem" width="70%" styleClass="mb-3"></p-skeleton>
          <p-skeleton height="2.5rem" width="30%"></p-skeleton>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="blog-search-section">
  <div class="container">
    <div class="search-container">
      <div class="search-header">
        <h3 class="search-title">
          <i class="icofont-search"></i>
          Rechercher des Articles
        </h3>
        <p class="search-subtitle">Trouvez rapidement les articles qui vous intéressent</p>
      </div>
      
      <div class="search-form-wrapper">
        <div class="search-input-wrapper">
          <i class="icofont-search search-icon"></i>
          <input 
            type="text" 
            class="form-control search-input" 
            placeholder="Rechercher par titre, contenu ou catégorie..." 
            [(ngModel)]="search" 
            name="search" 
            autocomplete="off"
          >
          <button class="search-btn" type="button">
            <i class="icofont-search"></i>
          </button>
        </div>
        
        <div class="search-stats">
          <span class="stats-text">
            <i class="icofont-document"></i>
            {{ filteredTeam?.length || articles?.length }} article(s) trouvé(s)
          </span>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="blog-articles-section">
  <div class="container">
    <div class="section-header">
      <h2 class="section-title">
        <i class="icofont-newspaper"></i>
        Toutes les Actualités
      </h2>
      <p class="section-subtitle">Découvrez notre collection complète d'articles</p>
    </div>
    
    <!-- Articles Grid -->
    <div class="articles-grid" *ngIf="articles && !loading">
      <div class="article-card" *ngFor="let article of filteredTeam; let i = index">
        <div class="article-image">
          <img [src]="article.media" [alt]="article.title">
          <div class="article-overlay">
            <div class="overlay-content">
              <a [routerLink]="article.slug" class="read-more-btn">
                <i class="icofont-eye"></i>
                Lire l'article
              </a>
            </div>
          </div>
          <div class="article-date">
            <span class="date-day">{{ article.publishon_on|date:'dd' }}</span>
            <span class="date-month">{{ article.publishon_on|date:'MMM' }}</span>
          </div>
        </div>
        
        <div class="article-content">
          <div class="article-meta">
            <span class="article-category">
              <i class="icofont-tag"></i>
              Actualité
            </span>
            <span class="article-time">
              <i class="icofont-clock-time"></i>
              {{ article.publishon_on|date:'HH:mm' }}
            </span>
          </div>
          
          <h3 class="article-title">
            <a [routerLink]="article.slug">{{ article.title }}</a>
          </h3>
          
          <p class="article-excerpt">
            Découvrez les dernières informations et développements importants de la BSTP...
          </p>
          
          <div class="article-footer">
            <a [routerLink]="article.slug" class="read-more-link">
              Lire Plus
              <i class="icofont-arrow-right"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Loading Skeleton for Articles -->
    <div class="articles-skeleton" *ngIf="loading">
      <div class="article-skeleton" *ngFor="let i of [0,1,2,3,4,5]">
        <div class="skeleton-image">
          <p-skeleton height="250px" width="100%" styleClass="rounded-3"></p-skeleton>
        </div>
        <div class="skeleton-content">
          <div class="skeleton-meta">
            <p-skeleton height="1rem" width="30%" styleClass="mb-2"></p-skeleton>
            <p-skeleton height="1rem" width="20%"></p-skeleton>
          </div>
          <p-skeleton height="1.5rem" width="90%" styleClass="mb-2"></p-skeleton>
          <p-skeleton height="1rem" width="100%" styleClass="mb-2"></p-skeleton>
          <p-skeleton height="1rem" width="70%" styleClass="mb-3"></p-skeleton>
          <p-skeleton height="1.5rem" width="40%"></p-skeleton>
        </div>
      </div>
    </div>
    
    <!-- No Results -->
    <div class="no-results-section" *ngIf="articles && filteredTeam?.length === 0 && !loading">
      <div class="no-results-content text-center">
        <div class="no-results-icon">
          <i class="icofont-search"></i>
        </div>
        <h3 class="no-results-title">Aucun article trouvé</h3>
        <p class="no-results-subtitle">
          Aucun article ne correspond à votre recherche. 
          Essayez de modifier vos critères de recherche.
        </p>
        <div class="no-results-actions">
          <button class="btn btn-primary" (click)="clearSearch()">
            <i class="icofont-refresh"></i>
            Voir tous les articles
          </button>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="blog-newsletter-section">
  <div class="container">
    <div class="newsletter-content text-center">
      <div class="newsletter-icon">
        <i class="icofont-envelope"></i>
      </div>
      <h2 class="newsletter-title text-white">Restez Informé</h2>
      <p class="newsletter-subtitle">
        Recevez nos dernières actualités directement dans votre boîte mail
      </p>
      <div class="newsletter-form">
        <div class="input-group">
          <input 
            type="email" 
            class="form-control" 
            placeholder="Votre adresse email..."
          >
          <button class="btn btn-primary" type="button">
            <i class="icofont-send-mail"></i>
            S'abonner
          </button>
        </div>
      </div>
    </div>
  </div>
</section>
